(() => {
  const root = window.Shopify?.routes?.root || '/';
  const definitions = [
    {id:'SDK-647720', parent:66219911676253, giftOffer:'FGT-416707'},
    {id:'SDK-722773', parent:66266719060317, giftOffer:'FGT-845792'}
  ];
  const labels = JSON.parse(document.getElementById('rodier-box-strings').textContent);
  const catalog = JSON.parse(document.getElementById('rodier-box-catalog').textContent);
  const instances = new Map();
  let current = [];
  let queue = Promise.resolve();
  let pending = 0;
  let failed = false;
  let dialog;
  const normalize = lines => lines.map(line=>({...line,properties:Array.isArray(line.properties)?Object.fromEntries(line.properties):line.properties||{},components:normalize(line.components||[])}));
  const boxId = line => String(line.properties?.Box || line.properties?.['Box ID'] || '');
  const definition = line => definitions.find(d => d.id === line.properties?._EasyBundleId || d.id === line.properties?.EasyBundleId || Number(line.id) === d.parent);
  const isGift = line => Boolean(line.properties?._free_gift);
  const node = (tag, text, attrs={}) => {
    const element = document.createElement(tag);
    if (text !== undefined) element.textContent = text;
    Object.entries(attrs).forEach(([key,value]) => element.setAttribute(key,value));
    return element;
  };
  const request = async (path, data) => {
    const response = await fetch(root+path, data === undefined ? {cache:'no-store'} : {
      method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(data)
    });
    const result = await response.json();
    if (!response.ok || result.errors || result.status >= 400) throw new Error(result.description || result.message || 'Cart request failed');
    return result;
  };
  const state = async () => {
    const sections = await request('?sections=rodier-bundle-state');
    const source = new DOMParser().parseFromString(sections['rodier-bundle-state'],'text/html').querySelector('#rodier-bundle-cart-data');
    if (!source) throw new Error('Cart data unavailable');
    current = normalize(JSON.parse(source.textContent));
    return current;
  };
  const notice = (text, error=false) => {
    let element = document.getElementById('rodier-box-status');
    if (!element) {
      element = node('div','',{id:'rodier-box-status',role:'status','aria-live':'polite'});
      document.body.append(element);
    }
    element.textContent = text;
    element.classList.toggle('rodier-box-error',error);
    element.hidden = !text;
  };
  const busy = () => {
    document.body.classList.toggle('rodier-box-updating',pending>0);
    document.querySelectorAll('button[name="checkout"],input[name="checkout"]').forEach(button => {
      if (pending || failed) {
        if (!button.disabled) button.dataset.rodierDisabled = 'true';
        button.disabled = true;
      } else if (button.dataset.rodierDisabled) {
        button.disabled = false;
        delete button.dataset.rodierDisabled;
      }
    });
  };
  const refresh = async () => {
    const sections = await request('?sections=cart-drawer,cart-bubble'+(document.getElementById('Cart')?',main-cart':''));
    for (const [id, section, selector] of [['Cart-Drawer','cart-drawer','.cart-drawer'],['cart-drawer-toggle','cart-bubble','.thb-item-count'],['Cart','main-cart','.thb-cart-form']]) {
      const target = document.getElementById(id);
      if (!target || !sections[section]) continue;
      const content = new DOMParser().parseFromString(sections[section],'text/html').querySelector(selector);
      if (content) (target.querySelector(selector)||target).innerHTML = content.innerHTML;
    }
    document.getElementById('Cart-Drawer')?.removeProductEvent();
    document.getElementById('Cart-Drawer')?.notesToggle();
    document.getElementById('Cart')?.removeProductEvent();
    await state();
    decorate();
    busy();
    document.dispatchEvent(new CustomEvent('line-item:change:end',{detail:{cart:await request('cart.js')}}));
  };
  const run = task => {
    pending++;
    busy();
    notice(labels.updating);
    const result = queue.catch(()=>{}).then(task).then(async value => {
      failed = false;
      await refresh();
      return value;
    }).catch(error => {
      failed = true;
      notice(labels.error,true);
      console.error('Rodier Box',error);
      throw error;
    }).finally(()=>{
      pending--;
      busy();
      if (!pending && !failed) notice('');
    });
    queue = result;
    return result;
  };
  const wait = async test => {
    const started = Date.now();
    while (!test()) {
      if (Date.now()-started>20000) throw new Error('Easy Bundle unavailable');
      await new Promise(resolve=>setTimeout(resolve,100));
    }
  };
  const instance = async def => {
    if (!instances.has(def.id)) instances.set(def.id,(async()=>{
      await wait(()=>window.gbbExtEmbed?.f?.fetchBundleConfig);
      const config = await window.gbbExtEmbed.f.fetchBundleConfig(def.id);
      if (!config || config.bundleStatus !== 'ACTIVE') throw new Error('Offer unavailable');
      if (!window.gbbSdk) {
        window.gbbExtEmbed.f.importSDKAssets({offerId:def.id,bundleType:config.bundleType,bundleDesignTemplate:config.bundleDesignTemplate},false);
        await wait(()=>window.gbbSdk?.init);
      }
      if (window.gbbSdk._initialized) {
        const bundles = window.gbbSdk.settings.bundlesData ||= [];
        if (!bundles.some(b=>b.offerId===def.id)) bundles.push(config);
      } else {
        await wait(()=>window.easybundles_ext_data?.userData);
        const bundles = window.easybundles_ext_data.mixAndMatchData ||= [];
        if (!bundles.some(b=>b.offerId===def.id)) bundles.push(config);
      }
      const sdk = await window.gbbSdk.init({offerId:def.id,initFetch:steps=>Object.fromEntries(Object.keys(steps).map(key=>[key,'all']))});
      if (!sdk) throw new Error('Bundle initialization failed');
      await sdk.category.f.fetchAllProducts(Object.keys(sdk.category.state.categoriesData));
      await wait(()=>sdk.freeGift.f.isFetched());
      return sdk;
    })().catch(error=>{instances.delete(def.id);throw error;}));
    return instances.get(def.id);
  };
  const contextFor = (sdk, productId) => {
    for (const [id, category] of Object.entries(sdk.category.state.categoriesData)) {
      if ((category.products||[]).some(product=>String(product.id)===String(productId))) return {categoryId:id,stepId:category.stepId};
    }
    return null;
  };
  const prepare = async (sdk, selection) => {
    await sdk.f.resetBundle();
    const quantities = new Map();
    for (const item of selection) quantities.set(String(item.id),(quantities.get(String(item.id))||0)+Number(item.quantity));
    for (const [id,quantity] of quantities) {
      if (!Number.isSafeInteger(quantity) || quantity<1) throw new Error('Invalid quantity');
      const variant = sdk.f.getVariantDataById(id);
      const context = variant && contextFor(sdk,variant.product_id);
      if (!variant || !context || !variant.available) throw new Error('Variant unavailable');
      const result = sdk.f.addProductToBundle({...context,variantId:id,quantity,showToast:false});
      if (!result?.ok) throw new Error(result?.data?.message || 'Invalid selection');
    }
    const valid = sdk.f.validateBeforeAddBundleToCart({showToast:false});
    if (!valid?.ok) throw new Error(valid?.data?.message || 'Invalid bundle');
    const payload = sdk.cart.utility.preparePayloadForAdd();
    if (!payload.bundleItems?.length) throw new Error('Empty payload');
    return payload;
  };
  const selections = lines => lines.flatMap(line => (line.components?.length ? line.components : [line]).map(component=>({id:component.id,quantity:Number(component.quantity)*(line.components?.length ? Number(line.quantity) : 1)})));
  const linked = (items, parents) => {
    const ids = new Set(parents.map(boxId).filter(Boolean));
    return items.filter(item=>isGift(item)&&ids.has(boxId(item)));
  };
  const removeLines = async lines => {
    if (lines.length) await request('cart/update.js',{updates:Object.fromEntries(lines.map(line=>[line.key,0]))});
  };
  const replace = async (def, selection, oldLines) => {
    if (!selection.length) {
      const items = await state();
      await removeLines([...oldLines,...linked(items,oldLines.filter(definition))]);
      return;
    }
    const sdk = await instance(def);
    const payload = await prepare(sdk,selection);
    const parents = oldLines.filter(definition);
    const originalIds = new Set(parents.map(line=>line.properties?._originalOfferId).filter(Boolean));
    const looseKeys = new Set(oldLines.filter(line=>!definition(line)).map(line=>line.key));
    const oldGiftBoxes = new Set(parents.map(boxId).filter(Boolean));
    const before = await state();
    const beforeKeys = new Set(before.map(line=>line.key));
    let added = false;
    try {
      const response = await window.gbbSdkHelpers.utility.executeAddToCart(payload);
      if (!response || response.status>=400 || response.errors) throw new Error('Bundle add failed');
      added = true;
      const after = await state();
      const fresh = after.find(line=>line.properties?._originalOfferId===payload.cartOfferId);
      if (!fresh || !fresh.components?.length) throw new Error('Bundle transformation not confirmed');
      const remove = after.filter(line=>originalIds.has(line.properties?._originalOfferId)||looseKeys.has(line.key)||(isGift(line)&&oldGiftBoxes.has(boxId(line))));
      await removeLines(remove);
      const verified = await state();
      if (verified.some(line=>originalIds.has(line.properties?._originalOfferId)||looseKeys.has(line.key))) throw new Error('Previous selection was not removed');
    } catch (error) {
      if (added) {
        const after = await state();
        const originalsPresent = before.filter(line=>oldLines.some(old=>old.key===line.key)).every(line=>after.some(value=>value.key===line.key));
        if (originalsPresent) await removeLines(after.filter(line=>!beforeKeys.has(line.key)&&(line.properties?._originalOfferId===payload.cartOfferId||(isGift(line)&&boxId(line)===String(payload.boxId)))));
      }
      throw error;
    } finally {
      await sdk.f.resetBundle();
    }
  };
  const orphanGifts = items => items.filter(line=>isGift(line)&&definitions.some(def=>String(line.properties._free_gift_offer_id||'').startsWith(def.giftOffer+'_'))&&!items.some(parent=>definition(parent)&&boxId(parent)===boxId(line)));
  const reconcile = async () => {
    await removeLines(orphanGifts(await state()));
    for (const def of definitions) {
      const items = await state();
      const parents = items.filter(line=>definition(line)?.id===def.id);
      const possible = items.filter(line=>!definition(line)&&!isGift(line)&&!line.properties?._bundleOfferId&&(catalog[def.id]||[]).includes(line.product_id));
      if (!possible.length && parents.length<2) continue;
      const sdk = await instance(def);
      const loose = possible.filter(line=>contextFor(sdk,line.product_id));
      if (!loose.length && parents.length<2) continue;
      await replace(def,selections([...parents,...loose]),[...parents,...loose]);
    }
  };
  const removeBox = async key => {
    const items = await state();
    const parent = items.find(item=>item.key===key);
    if (!parent || !definition(parent)) return;
    await removeLines([parent,...linked(items,[parent])]);
  };
  const decorate = () => {
    current.filter(definition).forEach(line=>{
      document.querySelectorAll('cart-drawer .product-card-small--link,theme-cart .product-card-small--link').forEach(link=>{
        if (!link.getAttribute('href')?.includes('/products/')) return;
        const item = link.closest('[id^="CartDrawerItem-"],[id^="CartItem-"]');
        if (!item || !link.getAttribute('href').includes(String(line.id))) return;
        item.dataset.rodierBoxKey = line.key;
        if (!item.querySelector('.rodier-edit-box')) {
          const button = node('button',labels.edit,{type:'button',class:'rodier-edit-box text-button','data-box-key':line.key});
          link.after(button);
        }
      });
    });
  };
  const openEditor = async key => {
    const items = await state();
    const line = items.find(item=>item.key===key);
    const def = line && definition(line);
    if (!def) return;
    notice(labels.updating);
    const sdk = await instance(def);
    notice('');
    dialog?.remove();
    dialog = node('dialog','',{class:'rodier-box-editor','aria-labelledby':'rodier-box-editor-title'});
    const form = node('form','',{class:'rodier-box-editor-form'});
    form.append(node('h2',labels.title,{id:'rodier-box-editor-title'}));
    const rows = node('div','',{class:'rodier-box-editor-rows'});
    const products = Object.values(sdk.state.productsDataMapByProductId).filter(product=>contextFor(sdk,product.id)&&product.variants?.some(variant=>variant.available));
    const addRow = selected => {
      const row = node('div','',{class:'rodier-box-editor-row'});
      const productLabel = node('label',labels.product);
      const productSelect = node('select','',{'aria-label':labels.product});
      const selectedVariant = selected && sdk.f.getVariantDataById(selected.id);
      products.forEach(product=>{
        const option = node('option',product.title,{value:String(product.id)});
        option.selected = String(product.id)===String(selectedVariant?.product_id);
        productSelect.append(option);
      });
      productLabel.append(productSelect);
      const sizeLabel = node('label',labels.size);
      const sizeSelect = node('select','',{'aria-label':labels.size,class:'rodier-box-variant'});
      const fillSizes = () => {
        sizeSelect.replaceChildren();
        const product = products.find(item=>String(item.id)===productSelect.value);
        product?.variants.forEach(variant=>{
          if (!variant.available && String(variant.id)!==String(selected?.id)) return;
          const option = node('option',variant.public_title||variant.title,{value:String(variant.id)});
          option.disabled = !variant.available;
          option.selected = String(variant.id)===String(selected?.id);
          sizeSelect.append(option);
        });
      };
      fillSizes();
      productSelect.addEventListener('change',fillSizes);
      sizeLabel.append(sizeSelect);
      const quantityLabel = node('label',labels.quantity);
      const quantity = node('input',undefined,{type:'number',min:'1',step:'1',required:'',value:String(selected?.quantity||1),'aria-label':labels.quantity,class:'rodier-box-quantity'});
      quantityLabel.append(quantity);
      const remove = node('button',labels.remove,{type:'button',class:'text-button'});
      remove.addEventListener('click',()=>row.remove());
      row.append(productLabel,sizeLabel,quantityLabel,remove);
      rows.append(row);
    };
    selections([line]).forEach(addRow);
    form.append(rows);
    const add = node('button',labels.add,{type:'button',class:'text-button rodier-box-add-row'});
    add.addEventListener('click',()=>addRow());
    const gift = node('p',labels.gift);
    const actions = node('div','',{class:'rodier-box-editor-actions'});
    const cancel = node('button',labels.cancel,{type:'button',class:'button outline'});
    cancel.addEventListener('click',()=>dialog.close());
    const save = node('button',labels.save,{type:'submit',class:'button'});
    actions.append(cancel,save);
    form.append(add,gift,actions);
    form.addEventListener('submit',event=>{
      event.preventDefault();
      if (!form.reportValidity()) return;
      const selection = [...rows.children].map(row=>({id:Number(row.querySelector('.rodier-box-variant').value),quantity:Number(row.querySelector('.rodier-box-quantity').value)}));
      save.disabled = true;
      run(()=>replace(def,selection,[line])).then(()=>dialog.close()).catch(()=>{save.disabled=false;});
    });
    dialog.append(form);
    document.body.append(dialog);
    dialog.showModal();
  };
  document.addEventListener('click',event=>{
    const edit = event.target.closest('.rodier-edit-box');
    if (edit) {
      event.preventDefault();event.stopImmediatePropagation();
      if (!pending) openEditor(edit.dataset.boxKey).catch(error=>{notice(labels.error,true);console.error(error);});
      return;
    }
    const remove = event.target.closest('.remove');
    const item = remove?.closest('[data-rodier-box-key]');
    if (item) {
      event.preventDefault();event.stopImmediatePropagation();
      if (!pending) run(()=>removeBox(item.dataset.rodierBoxKey)).catch(()=>{});
    }
  },true);
  document.addEventListener('submit',event=>{
    if (!event.submitter?.matches('[name="checkout"]')) return;
    if (pending || failed) {event.preventDefault();event.stopImmediatePropagation();notice(failed?labels.error:labels.updating,failed);}
  },true);
  document.addEventListener('cart:item-added',()=>run(reconcile).catch(()=>{}));
  document.addEventListener('line-item:change:end',event=>{
    if (Object.hasOwn(event.detail||{},'quantity')) run(reconcile).catch(()=>{});
  });
  document.addEventListener('gbb-add-bundle-to-cart:success',event=>{
    const id=event.detail?.offerId;
    if (!definitions.some(def=>def.id===id)) return;
    setTimeout(()=>run(async()=>{
      const sdk=window.gbbSdk?.[id];
      if (sdk) await wait(()=>!sdk.f.getCartData().items?.length);
      await reconcile();
    }).catch(()=>{}),100);
  });
  let decorating=false;
  const observer=new MutationObserver(()=>{
    if (decorating) return;
    decorating=true;
    requestAnimationFrame(()=>{decorate();busy();decorating=false;});
  });
  observer.observe(document.getElementById('wrapper')||document.body,{childList:true,subtree:true});
  try {current=normalize(JSON.parse(document.getElementById('rodier-bundle-cart-data')?.textContent||'[]'));} catch {}
  decorate();
  if (orphanGifts(current).length || definitions.some(def=>current.filter(line=>definition(line)?.id===def.id).length>1 || current.some(line=>!definition(line)&&!isGift(line)&&(catalog[def.id]||[]).includes(line.product_id)))) {
    run(reconcile).catch(()=>{});
  }
})();
